import { render, staticRenderFns } from "./zhanghu-list.vue?vue&type=template&id=3501e1ce&scoped=true&"
import script from "./zhanghu-list.vue?vue&type=script&lang=ts&"
export * from "./zhanghu-list.vue?vue&type=script&lang=ts&"
import style0 from "./zhanghu-list.vue?vue&type=style&index=0&id=3501e1ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3501e1ce",
  null
  
)

export default component.exports